/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PopupDto } from '../models/PopupDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PopupService {

    /**
     * @param id 
     * @param version 
     * @returns PopupDto OK
     * @throws ApiError
     */
    public static getPopupById(
id: number,
version: string,
): CancelablePromise<PopupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Popup/{id}',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns PopupDto OK
     * @throws ApiError
     */
    public static getAvailablePopup(
version: string,
): CancelablePromise<PopupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Popup/Available',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param id 
     * @param version 
     * @returns any OK
     * @throws ApiError
     */
    public static markAsVisited(
id: number,
version: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Popup/{id}/Visited',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

}
